import { render, staticRenderFns } from "./RelationshipFieldManySelect.vue?vue&type=template&id=4a1a6902"
import script from "./RelationshipFieldManySelect.vue?vue&type=script&lang=js"
export * from "./RelationshipFieldManySelect.vue?vue&type=script&lang=js"
import style0 from "./RelationshipFieldManySelect.vue?vue&type=style&index=0&id=4a1a6902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VIcon,VListItem,VListItemAction,VListItemTitle})
